import Moment from 'moment';
import BrowserUtil from '../../../util/BrowserUtil';
import * as Constants from './Constants';
import CloudDisconnectIcon from '../../../theme/icons/assets/CloudDisconnected.svg';
import CloudConnectIcon from '../../../theme/icons/assets/CloudON.svg';
import DeviceSoloIcon from '../../../theme/icons/assets/device solo.svg';
import Polyglot from 'node-polyglot';
import { Device, DeviceDataAPIResponse } from './device.model';
import { getPolyglot } from '../../../i18n';
import {
  CommanderStatusAPIResponse,
  DeviceCloudConnectivityAttributes,
} from '../commander-status/api/CommanderStatusAPI.model';
import { DigitalChannelEventMixed } from '../../monitoring/api/monitoring.model';
import { DeviceStatus } from '../../CUActions/api/CUActions.model';
import { getDigitalEventValue } from '../../monitoring/api/util/mapDigitalEvent';

const browserUtil = new BrowserUtil();

/**
 * Model Device
 * This class transform the devices received by  the backend to the needed structure
 */
class DeviceModel {
  polyglot: Polyglot;
  readonly STATUS_INPROGRESS = Constants.STATUS_INPROGRESS;
  readonly STATUS_NEW = Constants.STATUS_NEW;
  static readonly deviceIcon = DeviceSoloIcon;
  constructor(polyglot: Polyglot = getPolyglot()) {
    this.polyglot = polyglot;
  }

  /**
   * Cloud connectivity status:
   * this function set the connectivity status:
   * First it will check if the field state.connected is defined if not then the
   * connection is defined using the last ping time.
   * @param timestamp lastPingTime
   * @param object state {connected, state, deviceID, mqttconnected}
   * @return array [connectivity{true, false}, icon, tooltip]
   */
  cloudConnectivityStatus = (
    lastPingTime?: number,
    state: CommanderStatusAPIResponse | null = null
  ): DeviceCloudConnectivityAttributes => {
    let cloudConnectivity = false;
    let toolTip = `${this.polyglot.t(
      'device.tooltip.cloud_connection_inactive'
    )} ${
      !lastPingTime
        ? this.polyglot.t('general.unknown')
        : Moment(lastPingTime).format('L LTS')
    }`;

    if (state && state.vpnConnected) {
      cloudConnectivity = state.vpnConnected;
      toolTip = this.polyglot.t('device.tooltip.cloud_connection_active');
    }

    return {
      cloudConnectivity,
      cloudConnectivityIcon: cloudConnectivity
        ? CloudConnectIcon
        : CloudDisconnectIcon,
      cloudConnectivityTooltip: toolTip,
    };
  };

  /**
   * Get events
   * @param array devicesControlUnits
   */
  static getEvents = (devicesControlUnits: any[]) => {
    let events: any[] = [];
    devicesControlUnits.forEach((device: { controlunits: any[] }) => {
      device.controlunits.forEach((controlUnits: { events: any[] }) => {
        if (controlUnits.events.length > 0) {
          events = events.concat(
            controlUnits.events.map((event: { id: any }) => event.id)
          );
        }
      });
    });
    events = [...new Set(events)];
    return events;
  };

  /**
   * Get default icon if not exist
   * @param iconURL
   * @returns
   */
  static getDeviceIcon = (iconURL?: string | null) => {
    /* device icon */
    if (!iconURL) {
      return DeviceSoloIcon;
    } else {
      return browserUtil.getIsPhone() ? `${iconURL}?icon?height=35` : iconURL;
    }
  };

  static getLatestDigitalValue = (
    onEvent: DigitalChannelEventMixed | undefined,
    onActionCollection: DeviceStatus | undefined
  ) => {
    const eventValue =
      onEvent && getDigitalEventValue(onEvent.value, onEvent?.metadata);
    if (onActionCollection && onEvent) {
      // compare timestamps and return the latest value
      return onActionCollection.messageTimestamp > onEvent.timestamp
        ? onActionCollection.value
        : eventValue;
    }
    return eventValue ?? onActionCollection?.value;
  };
}

export default DeviceModel;
